// components/CardSlider.jsx
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import "./cardSlider.css";

const cards = [
  {
    title: "SME Energy Saving Tips",
    description: "Practical advice to help small businesses cut energy costs effectively.",
    image: "/images/energy.jpeg",
  },
  {
    title: "Third Party Costs",
    description: "Understand additional charges in your energy bills and how to manage them.",
    image: "/images/tpp.jpeg",
  },
  {
    title: "Reduce Electricity Bills",
    description: "Smart strategies to bring down your business electricity expenses.",
    image: "/images/lessEnergy.jpg",
  },
  {
    title: "Employee Awareness",
    description: "Empower your team with energy-saving habits and best practices.",
    image: "/images/Employe.jpeg",
  },
  {
    title: "Save Energy in the Office",
    description: "Office-specific tips to minimize energy waste and reduce overhead.",
    image: "/images/safeEnergy.jpeg",
  },
  {
    title: "Custom Energy Plans",
    description: "Get bespoke plans tailored to your business utility needs.",
    image: "/images/custom.jpg",
  },
];

const CardSlider = () => {
  return (
    <div className="card-slider">
      <Swiper
        modules={[Navigation]}
        spaceBetween={20}
        slidesPerView={3}
        navigation
        breakpoints={{
          1024: { slidesPerView: 3 },
          768: { slidesPerView: 2 },
          0: { slidesPerView: 1 },
        }}
      >
        {cards.map((card, index) => (
          <SwiperSlide key={index}>
            <div className="cardSlide">
              <img src={card.image} alt={card.title} className="card-img" />
              <div className="card-content">
                <h3>{card.title}</h3>
                <p>{card.description}</p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default CardSlider;
